<template lang="pug">
  .kimple-folder-detail(v-if='kimpleFolderDetail')
    .kimple-folder-content-header.width-100
      .main-container
        .row.middle.width-100.m-bottom-3.gray.bold(v-if='redirected')
          simple-svg.gray-icon.m-right-1(:filepath='infoIcon' :width='"20px"' :height='"20px"')
          span.text-normal.bold.gray(v-if='availableLanguages.length === 1')
            | {{ $t('kimpleFolderContent.redirection') }}
            | {{ $t(`languages.${kimpleFolderAvailableLanguages[0]}`) }}
          .row.middle.text-normal.bold.gray(v-else)
            | {{ $t('kimpleFolderContent.redirection') }}
            | {{ $t(`languages.${kimpleFolderAvailableLanguages[0]}`) }}
            | {{ $t('kimpleFolderContent.and') }}
            | {{ $t(`languages.${kimpleFolderAvailableLanguages[1]}`) }}
        .row.middle.relative.m1-top-24.m4-bottom-6
          .row.width-100.middle.folder-information
            simple-svg.dark-gray-icon.m-right-05(:filepath='folderIcon' :width='"20px"' :height='"20px"')
            router-link.text-normal.m-right-05(to='/folders')
              | {{ $t('kimpleFolderContent.root') }}
            simple-svg.dark-gray-icon.m-right-05(:filepath='rightArrowIcon' :width='"15px"' :height='"15px"')
            simple-svg.blue-icon.m-right-05(:filepath='resourceIcon' :width='"20px"' :height='"20px"')
            .text-normal.blue.bold
              | {{ kimpleFolderDetail.title  }}
          .row.middle.end.width-100
            button.secondary-button.with-icon.m4-left-6.copy-button(type='button', :title='$t("kimpleFolderCard.copyFolderInfo")' :disabled='isCopying' @click='copyFolder')
              simple-svg.m4-right-2(:filepath='copyIcon' :width='"20px"' :height='"20px"')
              | {{ $t('folders.copy')}}
            button.primary-button.with-icon.m4-left-6(type='button' @click='openShareFolderModal')
              simple-svg.white-icon.m4-right-2(:filepath='shareIcon' :width='"20px"' :height='"20px"')
              | {{ $t('folders.share')}}
          language-selector.row.middle.center.m-left-2(
            v-if='availableLanguages && availableLanguages.length > 1'
            :languages='availableLanguages'
            :disabled='availableLanguages.length === 1'
            @change-resource-locale='reloadKimpleFolder'
            inner
          )
        .column
          .row.title-info.top.space-between.width-100
            .title.column.width-100.item-3
              h1.title-big.bolder
                | {{ kimpleFolderDetail.title }}
              .row.middle.m4-top-2.m4-bottom-4
                span.text-xsmall.dark-gray.m4-right-3
                  | {{ innerI18n.t('folders.createdOn', { date: creationDate }) }}
                span.text-xsmall.dark-gray.dot
                  | {{ innerI18n.t('kimpleFolderContent.by') }}
                .novelty-badge.m-left-2.row.middle(v-if='kimpleFolderDetail.novelty')
                  simple-svg(:filepath='noveltyBadgeIcon' width='15px' height='15px')
                  span.m-left-05.uppercase.bold {{ innerI18n.t('kimpleFolderContent.novelty') }}
              .html-text.text-small.m-bottom-2(v-html='kimpleFolderDetail.description' v-if='showDescription')
            .row.item-3.graphics-items.end.wrap(v-if='kimpleFolderDetail.resources.length >= 1 && !showDescription')
              .row.middle
                simple-svg.item-logo.dark-gray-icon(:filepath='calendarIcon' width='18px' height='18px')
                p.row.middle.text-small
                  | {{ innerI18n.tc('kimpleFolderContent.sessionsAmount', kimpleFolderDetail.classQuantity) }}
              .row.middle
                simple-svg.item-logo.dark-gray-icon(:filepath='bookIcon' width='18px' height='18px')
                p.row.middle.text-small
                  | {{ innerI18n.tc('kimpleFolderContent.resourcesAmount', kimpleFolderDetail.resources.length) }}
              .row.middle
                simple-svg.item-logo.dark-gray-icon(:filepath='areasIcon' width='18px' height='18px')
                p.row.middle.text-small
                  | {{ innerI18n.tc('kimpleFolderContent.subjectsAmount', kimpleFolderDetail.subjectIds.length) }}
              .row.middle
                simple-svg.item-logo.dark-gray-icon(:filepath='userIcon' width='18px' height='18px')
                p.row.middle.text-small
                  | {{ innerI18n.tc('kimpleFolderContent.agesAmount', kimpleFolderDetail.ageRange.length) }}
              .row.middle
                img.item-logo(src='../assets/SDG Wheel_Transparent_WEB.png' alt='kimple folder ods')
                p.row.middle.text-small
                  | {{ innerI18n.tc('kimpleFolderContent.sdgAmount', kimpleFolderDetail.odSs.length) }}
            .row.item-3.graphics-items.end.wrap(v-if='kimpleFolderDetail.resources.length >= 1 && showDescription')
              .column
                .row.middle.m-bottom-1
                  simple-svg.item-logo.dark-gray-icon(:filepath='calendarIcon' width='18px' height='18px')
                  p.row.middle.text-small.dark-gray
                    | {{ innerI18n.tc('kimpleFolderContent.sessions') }}
                .graphic-item-detail
                  p.row.middle.text-small
                    | {{ innerI18n.tc('kimpleFolderContent.sessionsAmount', kimpleFolderDetail.classQuantity) }}
              .column
                .row.middle.m-bottom-1
                  simple-svg.item-logo.dark-gray-icon(:filepath='bookIcon' width='18px' height='18px')
                  p.row.middle.text-small.dark-gray
                    | {{ innerI18n.tc('kimpleFolderContent.resources') }}
                .graphic-item-detail
                  p.row.middle.text-small
                    | {{ innerI18n.tc('kimpleFolderContent.resourcesAmount', kimpleFolderDetail.resources.length) }}
              .column
                .row.middle.m-bottom-1
                  simple-svg.item-logo.dark-gray-icon(:filepath='areasIcon' width='18px' height='18px')
                  p.row.middle.text-small.dark-gray
                    | {{ innerI18n.tc('kimpleFolderContent.subjects') }}
                .graphic-item-detail
                  p.row.middle.text-small(v-for='subjectId in kimpleFolderDetail.subjectIds')
                    | {{ getSubjectTranslation(subjectId) }}
              .column
                .row.middle.m-bottom-1
                  simple-svg.item-logo.dark-gray-icon(:filepath='userIcon' width='18px' height='18px')
                  p.row.middle.text-small.dark-gray
                    | {{ innerI18n.tc('kimpleFolderContent.ageRanges') }}
                .graphic-item-detail.column
                  span.folder-age-desc.m-bottom-1(v-for='ageRange in kimpleFolderDetail.ageRange' :style='getAgeRangeStyle(ageRange.mainColor)')
                    | {{ innerI18n.t('kimpleFolderContent.agesTag', { min: ageRange.minAge, max: ageRange.maxAge }) }}
          .column.m-bottom-2(v-if='showDescription')
            .row.middle.bold.m-bottom-1
              img.sdg-details-logo.m-right-1(src='../assets/SDG Wheel_Transparent_WEB.png' alt='kimple folder ods')
              | {{ innerI18n.t('kimpleFolderContent.sdgDetails') }}
            .sdg-grid.width-100.m4-left-9
              span(v-for='anOds in kimpleFolderDetail.odSs')
                img.sdg-card.m-right-1(:src='getOdsLogo(anOds.translationId)' :alt='anOds.translationId')
    button.row.center(@click='toggleCollapsableBox')
      .collapasable-logo(v-show='showDescription')
        simple-svg.red-icon(:filepath='upArrowIcon' width='12px')
      .collapasable-logo(v-show='!showDescription')
        simple-svg.red-icon(:filepath='downArrowIcon' width='12px')
    .main-container
      h3.title-medium.m-bottom-2
        | {{ $tc("kimpleFolderContent.resourcesAmountTitle", kimpleFolderDetail.resources.length) }}
      .grid.grid-columns-4.gap-20.m-bottom-4
        resource-card.m-top-4(
          v-for='resource in orderedResources'
          :key='resource.id'
          :resource='resource'
        )
      carousel.m-bottom-6(v-if='resources.length' :title='$t("folders.kimpleRecommends")')
        slide.m-right-05(v-for='resource in resources[0].resources' :key='resource.id')
          resource-card(:resource='resource')
    used-content-drawer
    share-kimple-folder-modal(v-if='showShareModal')
    create-sharing-group-modal(v-if='showCreateSharingGroupModal')
    edit-sharing-group-modal(v-if='showEditSharingGroupModal')
    add-sharing-group-members-modal(v-if='showAddSharingGroupMembersModal')
    choice-modal(v-if='showChoiceModal')
    vue-headful(:title='viewTitle')
    add-resource-modal(v-if='showAddResourceModal')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import amplitude from 'amplitude-js'

import ResourceCard from '@/components/ResourceCard'
import Carousel from '@/components/Carousel'
import CustomToast from '../components/CustomToast'
import ShareKimpleFolderModal from '@/components/Modals/ShareKimpleFolderModal'
import LanguageSelector from '@/components/LanguageSelector'
import AddResourceModal from '@/components/Resource/AddResource'
import CreateSharingGroupModal from '@/components/Modals/CreateSharingGroupModal'
import EditSharingGroupModal from '@/components/Modals/EditSharingGroupModal'
import ChoiceModal from '@/components/Modals/ChoiceModal'
import AddSharingGroupMembersModal from '@/components/Modals/AddSharingGroupMembersModal'
import UsedContentDrawer from '@/components/UsedContent/UsedContentDrawer'

import shareIcon from '@/assets/ic_share.svg'
import folderIcon from '@/assets/ic_folder.svg'
import resourceIcon from '@/assets/ic_resource.svg'
import rightArrowIcon from '@/assets/ic_chevron-right.svg'
import upArrowIcon from '@/assets/ic_chevron-up.svg'
import downArrowIcon from '@/assets/ic_chevron-down.svg'
import copyIcon from '@/assets/ic_copy.svg'
import calendarIcon from '@/assets/ic_calendar.svg'
import bookIcon from '@/assets/ic_book.svg'
import areasIcon from '@/assets/ic_areas.svg'
import userIcon from '@/assets/ic_user.svg'
import infoIcon from '@/assets/ic_info.svg'
import noveltyBadgeIcon from '@/assets/ic_novelty_badge.svg'

import { tabTitle, dateFormat } from '../utils/constants'
import { scrollTop } from '../utils/behavior'
import { i18n, innerI18n } from '../main'
import { supportedLanguages } from '../constants/languages'
import { toLowerCamelCase } from '../utils/string'

export default {
  name: 'folderContent',
  components: {
    CreateSharingGroupModal,
    UsedContentDrawer,
    AddSharingGroupMembersModal,
    ChoiceModal,
    EditSharingGroupModal,
    ResourceCard,
    Carousel,
    CustomToast,
    ShareKimpleFolderModal,
    LanguageSelector,
    AddResourceModal
  },
  data () {
    return {
      infoIcon,
      calendarIcon,
      bookIcon,
      areasIcon,
      userIcon,
      innerI18n,
      shareIcon,
      folderIcon,
      resourceIcon,
      rightArrowIcon,
      upArrowIcon,
      downArrowIcon,
      copyIcon,
      noveltyBadgeIcon,
      showDescription: true,
      origin: null,
      isCopying: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from) {
        vm.origin = from.name
      }
    })
  },
  computed: {
    ...mapState({
      kimpleFolderDetail: state => state.kimpleFolders.kimpleFolderDetail,
      availableLanguages: state => state.kimpleFolders.kimpleFolderDetail.availableLanguages,
      showShareModal: state => state.behavior.shareKimpleFolderModal.show,
      locale: state => state.behavior.locale,
      innerLocale: state => state.behavior.innerLocale,
      showCreateSharingGroupModal: state => state.behavior.createSharingGroupModal.show,
      showEditSharingGroupModal: state => state.behavior.editSharingGroupModal.show,
      showAddSharingGroupMembersModal: state => state.behavior.addSharingGroupMembersModal.show,
      showChoiceModal: state => state.behavior.choiceModal.show,
      resources: state => state.dashboard.resources,
      showAddResourceModal: state => state.behavior.addResourceModal.show,
      redirected: state => state.kimpleFolders.redirectedKimpleFolder,
      subjects: state => state.profile.subjects
    }),
    viewTitle() {
      return this.kimpleFolderDetail.title ? `${tabTitle} - ${this.kimpleFolderDetail.title}` : tabTitle
    },
    creationDate() {
      return moment(this.kimpleFolderDetail.createdAt).format(dateFormat)
    },
    toastStyles() {
      return {
        width: '100%',
        display: 'flex',
        'justify-content': 'center'
      }
    },
    orderedResources() {
      return this.kimpleFolderDetail.resources
        .map(res => res)
        .sort((a, b) => this.kimpleFolderDetail.orderResources.indexOf(a).order - this.kimpleFolderDetail.orderResources.indexOf(b).order)
    },
    kimpleFolderAvailableLanguages() {
      return supportedLanguages
        .filter(lang => this.availableLanguages.includes(lang.lang))
        .map(lang => lang.translation)
    }
  },
  async created() {
    await this.hydrateSubjects()
    const locale = this.$route.query.locale
    await this.getKimpleFolderDetails({ id: this.$route.params.id, locale: locale || this.locale })
    amplitude.getInstance().logEvent('Kimple folder', {
      id: this.kimpleFolderDetail.id,
      name: this.kimpleFolderDetail.title,
      origin: this.origin || 'Kimple folder'
    })
    this.changeInnerLocale(locale || this.kimpleFolderDetail.selectedLocale)
  },
  watch: {
    '$route' (to, from) {
      scrollTop()
    }
  },
  methods: {
    ...mapActions([
      'getKimpleFolderDetails',
      'showElement',
      'copyKimpleFolder',
      'changeInnerLocale',
      'hydrateSubjects'
    ]),
    reloadKimpleFolder() {
      this.getKimpleFolderDetails({ id: this.$route.params.id, locale: this.innerLocale })
    },
    openShareFolderModal() {
      this.showElement({
        element: 'shareKimpleFolderModal',
        props: {
          id: this.kimpleFolderDetail.id,
          locale: this.locale,
          folderLocale: this.innerLocale
        }
      })
    },
    getAgeRangeStyle(color) {
      return {
        '--age-color': color
      }
    },
    toggleCollapsableBox() {
      this.showDescription = !this.showDescription
    },
    async copyFolder() {
      this.isCopying = true
      const success = await this.copyKimpleFolder({ id: this.$route.params.id, locale: this.innerLocale })
      if (success) {
        this.$notify({
          group: 'custom-toast',
          duration: 6000,
          text: i18n.t('customToast.copyKimpleFolderSuccess'),
          type: 'success'
        })
        amplitude.getInstance().logEvent('Copy Kimple folder', {
          id: this.kimpleFolderDetail.id,
          name: this.kimpleFolderDetail.title
        })
      } else {
        this.$notify({
          group: 'custom-toast',
          duration: 6000,
          text: i18n.t('customToast.copyKimpleFolderError'),
          type: 'error'
        })
      }
      this.isCopying = false
    },
    getOdsLogo(ods) {
      return require(`@/assets/ods/${this.innerI18n.locale}/${ods}.png`)
    },
    getSubjectTranslation(id) {
      const subject = this.subjects.find(subject => subject.id === id)
      return subject ? innerI18n.t(`dashboard.subjectIds.${toLowerCamelCase(subject.translationId)}`) : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/sizes';
@import '../scss/variables/colors';

.kimple-folder-detail {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.novelty-badge {
  background-color: $yellow;
  border-radius: 12px;
  padding: 5px 10px;
}

.kimple-folder-content-header {
  padding-top: 30px;
  background-color: $light-gray;
}

.card-container {
  margin: 24px 15px 0 0;
}

.copy-button{
  &:disabled{
    opacity: 0.5;
    cursor: wait;
  }
}

.dot {
  padding-left: 16px;
  position: relative;

  &::before {
    background-color: $blue;
    border-radius: 100%;
    content: '';
    height: 5px;
    left: 0;
    position: absolute;
    top: 6px;
    width: 5px;
  }
}

.item-logo {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.item-info {
  width: 100%;
  max-width: 170px;
}

.folder-age-desc:not(.noage) {
  padding-left: 16px;
  position: relative;

  &::before {
    background-color: var(--age-color);
    border-radius: 100%;
    content: '';
    height: 8px;
    left: 0;
    position: absolute;
    top: 2.5px;
    width: 8px;
  }
}

.collapasable-logo {
  background-color: $light-gray;
  padding: 8px 40px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.graphics-items {
  margin-top: 15px;
  &>*:not(:last-child){
    margin-right: 20px;
  }
}

.graphic-item-detail {
  padding-left: 25px;
}

.sdg-details-logo{
  width: 25px;
  height: 25px;
}
.sdg-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, 50px);
  gap: 5px;
}
.sdg-card {
  box-shadow: 0 4px 8px 0 $shadow-gray;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  width: 50px;

  &:hover {
    box-shadow: 0 8px 16px 0 $dark-gray-translusent;
    transform: scale(1.3);
  }
}

@media screen and (max-width: $tablet-break) {
  .title-info{
    flex-direction: column;
    align-items: flex-start;
  }
  .graphics-items {
    justify-content: flex-start;
    margin-bottom: 10px;
    margin-top: 0;
  }
}
</style>
